import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Promise from 'bluebird';
import GiftInfo from './gift';
import UserAddresses from '../userAddresses';
import { editAddress } from 'shared/components/userAddresses/actions';
import { setAddress } from 'shared/components/address/actions';
import { toggleGift } from './actions';
import { validMobile } from 'shared/models/user';

const Icon = () => <span className="svg-icon svg-icon--location" />

class Collapsed extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.isGift && (_.isEmpty(nextProps.giftRecipient) || _.isEmpty(nextProps.giftMobile))) {
      this.props.expand();
    }
  }

  renderTitle() {
    return (
      <h2 className="checkout-section__title">
        Delivery Address
      </h2>
    )
  }

  renderSummary(props) {
    const { isGift, toggleGift } = props;
    const { address, zip, unit, notes } = props.address;
    const displayAddress = [address, unit, zip].filter(str => !_.isEmpty(str)).join(', ')
    const addDeliveryNotes = () => {
      props.expand();
      props.editAddress({...props.address});
    }

    return (
      <div className="checkout-summary">
        { isGift && (
          <div className="checkout-summary__gift-notes-container">
            <div className="text-overflow checkout-summary__gift-recipient">
              <span className="text-bold text-overflow">{props.giftRecipient}</span>
            </div>
            { props.giftNote && (
              <span>
                <span> - </span>
                <span className="quote-text">
                  <div className="text-overflow checkout-summary__gift-notes">
                    {props.giftNote}
                  </div>
                </span>
              </span>
            )}
          </div>
        )}

        <div>{ displayAddress }</div>
        { !props.address.shipping && (
          <div>
            { notes ?
              <div className="quote-text">
                <div className="text-overflow checkout-summary__notes">{notes}</div>
              </div> :
              <a className="link-text" onClick={() => addDeliveryNotes()}>Add Delivery Notes</a> }
          </div>
        )}

        <div className="checkout-summary__checkbox-container">
          <input
            type="checkbox"
            id="isGift"
            className="checkout-summary__checkbox"
            name="isGift"
            checked={isGift}
            onChange={toggleGift}
          />
          <label htmlFor="isGift">
            Send as a gift?
          </label>
        </div>
      </div>
    )
  }

  render() {
    return _.isEmpty(this.props.address) ?
      this.renderTitle() :
      this.renderSummary(this.props);
  }
}

Collapsed = connect(state => ({
  address: state.address,
  isGift: state.checkout.isGift,
  giftRecipient: state.checkout.giftRecipient,
  giftMobile: state.checkout.giftMobile,
  giftNote: state.checkout.giftNote
}), {
  toggleGift,
  editAddress
})(Collapsed);


class Expanded extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errors: {}
    }
  }

  validateRecipient(name) {
    if (_.isEmpty(name)) return "Recipient Name can't be blank"
  }

  validateMobile(number) {
    if (!validMobile(number)) return "Enter a valid mobile number"
  }

  validateGiftFields() {
    const { isGift, giftRecipient, giftMobile } = this.props;

    let errors = {};
    errors.giftRecipient = isGift ? this.validateRecipient(giftRecipient) : null;
    errors.giftMobile = isGift ? this.validateMobile(giftMobile) : null;

    this.setState({ errors })
    if (_.some(errors)) return Promise.reject(new Error());
    return Promise.resolve();
  }

  selectUserAddress(address) {
    const trackingParams = { page: 'Checkout', source: 'Saved Addresses' }
    return this.props.setAddress(address, { ...trackingParams, checkout: true })
  }

  setNewAddress(address) {
    const trackingParams = { page: 'Checkout', source: 'Checkout Form' }
    return this.props.setAddress(address, { ...trackingParams, checkout: true })
  }

  render() {
    return (
      <div>
        <h2 className="checkout-section__title checkout-section__title--expanded">
          Delivery Address
        </h2>

        <div className="checkout-section__checkbox-container">
          <label htmlFor="isGift">
            <span className="svg-icon svg-icon--gift" />
            <span>Send as a gift?</span>
          </label>
          <input
            type="checkbox"
            name="isGift"
            id="isGift"
            className="checkout-section__checkbox"
            checked={this.props.isGift}
            onChange={() => this.props.toggleGift()}
          />
        </div>

        <div className="checkout-form-container">
          { this.props.isGift && (
            <GiftInfo
              validateRecipient={(name) => this.validateRecipient(name)}
              validateMobile={(number) => this.validateMobile(number)}
              giftRecipientError={this.state.errors.giftRecipient}
              giftMobileError={this.state.errors.giftMobile}
            />
          )}

          <UserAddresses
            selectedAddress={this.props.address}
            onBeforeSubmit={() => this.validateGiftFields()}
            onSelectionChange={(address) => this.selectUserAddress(address)}
            onSelectionSubmit={() => this.props.collapse()}
            onNewAddressSubmit={(address) => this.setNewAddress(address)}
            onNewAddressSuccess={() => this.props.collapse()}
            onUpdateAddressSuccess={(address) => this.selectUserAddress(address)}
          />
        </div>
      </div>
    )
  }
}

Expanded = connect(state => ({
  isGift: state.checkout.isGift,
  giftRecipient: state.checkout.giftRecipient,
  giftMobile: state.checkout.giftMobile,
  address: state.address,
}), { toggleGift, setAddress })(Expanded);


export default {
  Icon,
  Collapsed,
  Expanded
};



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/deliveryAddress.js